module.exports = __webpack_public_path__ + "img/icon_coordinates7.f22ad750.png";